import React, { useEffect, useState } from "react";
import { Grid, Typography, TextField, Button, Link, Box } from "@mui/material";
import loginimg from "../Images/Loginimg.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// import axios from "axios";
// import Loadingbar from "../Loading/Loadingbar";

const textFieldStyles = {
  "& .MuiInputLabel-root": {
    fontFamily: "Poppins, sans-serif",
    fontSize: "0.8rem",
  },
  "& .MuiInputBase-input": {
    fontFamily: "Poppins, sans-serif",
    fontSize: "0.9rem",
  },

  // ⭐ Hover border
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#144FEE",
    borderWidth: "2px",
  },

  // ⭐ Focus border
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#144FEE",
    borderWidth: "2px",
  },
};

const Login = () => {
  const navigate = useNavigate();

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handlLogin = () => {
    setLoading(true);
    const payload = {
      username: userName,
      password: password,
    };
    axios
      .post(
        "https://iot-api.elantristechnologies.com/api/BP_Integration/LoginAuth",
        payload,
      )
      .then((res) => {
        if (res.data.status == "1") {
          navigate("/Home");
          sessionStorage.setItem("comp_name", res.data.comp_name);
          sessionStorage.setItem("cust_name", res.data.cust_name);
          sessionStorage.setItem("contact_name", res.data.contact_name);
          localStorage.setItem("token", res.data.token);
        } else {
          alert(res.data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      <Grid container sx={{ height: "100vh" }}>
        {/* Right Section */}
        <Grid
          size={{ lg: 7, xs: 12, md: 12, sm: 12 }}
          sx={{
            height: "100%", // important
            display: "flex",
            alignItems: "center",
            backgroundColor: " #FBF9F5",
          }}
        >
          <Grid sx={{ display: "flex", alignItems: "center" }}>
            {/* Background Image */}
            <Box
              component='img'
              src={loginimg}
              alt='login illustration'
              sx={{
                width: "100%",
                height: "100vh",
                objectFit: "contain", // 🔥 image full cover
                zIndex: 1,
              }}
            />
          </Grid>
        </Grid>
        {/* Left Section */}
        <Grid
          size={{ lg: 5, xs: 12, md: 12, sm: 12 }}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            bgcolor: "#fff",
            p: 4,
          }}
        >
          <Box sx={{ width: "100%", maxWidth: 420 }}>
            <Typography
              variant='h3'
              sx={{
                fontWeight: "bold",
                color: "#144FEE",
                mb: 4,
                fontFamily: "Poppins, sans-serif",
              }}
            >
              Customer Portal
            </Typography>

            <Typography
              variant='h5'
              sx={{
                fontWeight: 600,
                mb: 1,
                fontFamily: "Poppins, sans-serif",
                color: "#2e2e2e",
              }}
            >
              Sign in
            </Typography>
            <Typography
              variant='body2'
              sx={{ mb: 3, color: "#2e2e2e", fontFamily: "Poppins" }}
            >
              to access Accounts
            </Typography>

            <TextField
              fullWidth
              variant='outlined'
              placeholder='Name'
              sx={textFieldStyles}
              value={userName}
              onChange={(e) => {
                setUserName(e.target.value);
              }}
            />

            <TextField
              style={{ marginTop: "10px" }}
              fullWidth
              variant='outlined'
              placeholder='Password'
              type='password'
              sx={textFieldStyles}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />

            <Button
              variant='contained'
              fullWidth
              sx={{
                mt: 3,
                bgcolor: "#144FEE",
                textTransform: "none",
                fontFamily: "Poppins",
                fontWeight: 600,
                boxShadow: "none",
              }}
              onClick={() => {
                handlLogin();
                // navigate("/Home");
              }}
            >
              Next
            </Button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default Login;
